import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Provider from "pubsub-js";
import {
  productSelector,
  designsSelector,
  conditionSelector
} from "../selectors";
import priceFormat from "../services/lib/price-format";
import {
  BACKGROUND_COLOR_CHANGED,
  OBJECT_ADDED,
  OBJECT_REMOVED
} from "../constants/event-types";
import {getPriceFromScheme} from "../services/lib/get-price-from-scheme";
import withErrorBoundary from "../decorators/withErrorBoundary";
import {longCurrency} from "../../../utils/currency";

export class Price extends PureComponent {
  static propTypes = {
    product: PropTypes.object,
    designs: PropTypes.object,
    condition: PropTypes.object
  };
  state = {
    price: this.props.product.price.price
  };
  componentDidMount() {
    Provider.subscribe(BACKGROUND_COLOR_CHANGED, this.setPrice);
    Provider.subscribe(OBJECT_ADDED, this.setPrice);
    Provider.subscribe(OBJECT_REMOVED, this.setPrice);
  }
  componentWillUnmount() {
    Provider.unsubscribe(BACKGROUND_COLOR_CHANGED);
    Provider.unsubscribe(OBJECT_ADDED);
    Provider.unsubscribe(OBJECT_REMOVED);
  }
  setPrice = () => {
    const calcPrice = this.calculatePrice();
    if (calcPrice !== this.state.price) {
      this.setState({
        price: calcPrice
      });
    }
  };
  componentDidUpdate() {
    this.setPrice();
  }
  calculatePrice() {
    const {
      product: {meta},
      designs: designData,
      condition: {variants}
    } = this.props;
    return getPriceFromScheme(meta.price_data, {
      variants,
      designs: {
        data: designData,
        meta: meta.designs
      }
    });
  }
  render() {
    const {price} = this.state;
    const {currency} = this.props

    return <div className="product-price">{priceFormat(price)}{longCurrency(currency, price)}</div>;
  }
}

const mapStateToProps = (state) => ({
  product: productSelector(state),
  designs: designsSelector(state),
  condition: conditionSelector(state),
  currency: state.currency
});

export default connect(mapStateToProps)(withErrorBoundary(Price));
